import {createEntityAdapter, EntityAdapter} from '@ngrx/entity';
import {ExportJobDTO} from '../../openapi/export-openapi';


export const errorEventEntitiesAdapter: EntityAdapter<ExportJobDTO> = createEntityAdapter<ExportJobDTO>();
